import { Component } from "@angular/core";

@Component({
    selector: 'errorPage',
    templateUrl: './errorPage.component.html',
    styleUrls: ['./errorPage.component.css']
})
export class ErrorPageComponent{
    
}